// extracted by mini-css-extract-plugin
export default {"mainContent":"router_mainContent__vlAPl","content":"router_content__P2Dmj"};